import { AxiosError } from 'axios';
import type { ApiResponse } from '@shared/types';

export interface ApiErrorDetails {
  message: string;
  fieldErrors?: Record<string, string[]>;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof AxiosError) {
    const data = error.response?.data as ApiResponse<unknown> | undefined;
    return data?.message || fallback;
  }
  if (error instanceof Error) return error.message;
  return fallback;
}

export function getApiErrorDetails(error: unknown, fallback: string): ApiErrorDetails {
  if (error instanceof AxiosError) {
    const data = error.response?.data as ApiResponse<unknown> | undefined;
    return {
      message: data?.message || fallback,
      fieldErrors: data?.errors,
    };
  }
  if (error instanceof Error) return { message: error.message };
  return { message: fallback };
}
